class AuthHelper {
  isAuthenticated = () => !!window.sessionStorage.accessToken
}

export default new AuthHelper();
